import React, { PropsWithChildren } from "react";
import { Container } from "reactstrap";
import Menu from "../../../components/app/Menu";
import NotificationList from "../../../components/notification/NotificationList";
import { Header } from "./Header";

export class MenuLayout extends React.Component<PropsWithChildren> {
  render() {
    return (
      <>
        <div style={{ position: "absolute", width: "100%", zIndex: 1 }}>
          <NotificationList />
        </div>
        <Container style={{ maxWidth: 1400 }}>
          <Header />
        </Container>
        <Menu />
        <Container style={{ maxWidth: 1400 }}>{this.props.children}</Container>
      </>
    );
  }
}
